<script>
import axios from 'axios';
import { RestaurantsPath } from '../../../../path';
import Swal from "sweetalert2";

export default {    
  props: ["res"],
  data() {
    return {
      timings: [
        {
          day: "Monday",
          timings: [
            {
              start_time: null,
              end_time: null,
            },
          ],
          is_holiday: 0,
        },
        {
          day: "Tuesday",
          timings: [
            {
              start_time: null,
              end_time: null,
            },
          ],
          is_holiday: 0,
        },
        {
          day: "Wednesday",
          timings: [
            {
              start_time: null,
              end_time: null,
            },
          ],
          is_holiday: 0,
        },
        {
          day: "Thursday",
          timings: [
            {
              start_time: null,
              end_time: null,
            },
          ],
          is_holiday: 0,
        },
        {
          day: "Friday",
          timings: [
            {
              start_time: null,
              end_time: null,
            },
          ],
          is_holiday: 0,
        },
        {
          day: "Saturday",
          timings: [
            {
              start_time: null,
              end_time: null,
            },
          ],
          is_holiday: 0,
        },
        {
          day: "Sunday",
          timings: [
            {
              start_time: null,
              end_time: null,
            },
          ],
          is_holiday: 0,
        },
      ],
      baseUrl : process.env.VUE_APP_API_BACKEND_URL
    };
  },
  mounted (){
    this.getTimings();
  },
  methods: {
    copyTimings(index){
        let timing = JSON.stringify(this.timings[index].timings);
        console.log(timing);
        this.timings = this.timings.map(t => {
            t.timings = JSON.parse(timing)
            return t;
        });
    },
    async saveTimings(){
        try {
            let res = await axios.post(this.baseUrl + RestaurantsPath.SAVE_TIMINGS,{
                timings : this.timings,
                res_id : this.res.id,
            });
            if(res.data.status){
                Swal.fire("Success","",'success');
            }else{
                throw new Error(res.data.message);
            }
        } catch (error) {
            console.log(error);
            Swal.fire(error.message,"","error");
        }
    },
    async getTimings(){
        try {
            let res = await axios.get(this.baseUrl + RestaurantsPath.GET_TIMINGS,{
                params : {
                    res_id : this.res.id
                }
            });
            if(res.data.status){
                console.log(res.data.data);
                if(res.data.data.length != 0){
                    this.timings = res.data.data.map(r => {
                        if(r.timings.length == 0){
                            r.timings.push({
                                start_time : null,
                                end_time : null
                            });                            
                        }
                        return r
                    });
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
  },
};
</script>

<template>
  <b-card>
    <b-card-header> Timings For {{ res?.name }} </b-card-header>
    <b-card-body>
      <table class="table">
        <thead>
          <tr>
            <th>Day</th>
            <th>Is Holiday</th>
            <th>Timings</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(r, ri) in timings" :key="ri">
            <td>{{ r.day }}</td>
            <td>
              <b-checkbox v-model="r.is_holiday"></b-checkbox>
            </td>
            <td>
              <div v-if="r.is_holiday == false">
                <div v-if="ri == 0">
                    <b-button size="sm" class="mb-2" variant="success" @click="copyTimings(ri)"><i class="fa fa-copy"></i></b-button>
                </div>
                <div v-for="(t, ti) in r.timings" :key="ti">
                  <div class="d-flex align-items-center mt-2">
                    <b-timepicker
                      v-model="t.start_time"
                      class="mr-2"
                    ></b-timepicker>
                    <b-timepicker v-model="t.end_time"></b-timepicker>
                    <b-button
                      variant="success"
                      class="ml-2"
                      v-if="ti == 0"
                      @click="
                        () => {
                          r.timings.push({ start_time: null, end_time: null });
                        }
                      "
                      ><i class="fa fa-plus"></i
                    ></b-button>
                    <b-button
                      variant="danger"
                      class="ml-2"
                      v-if="ti !== 0"
                      @click="() => r.timings.splice(ti, 1)"
                      ><i class="fa fa-minus"></i
                    ></b-button>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card-body>
    <b-card-footer>
      <b-button variant="success" @click="saveTimings">Save</b-button>
    </b-card-footer>
  </b-card>
</template>

<style></style>
